import React, { useState } from 'react';
import DescriptionIcon from '@material-ui/icons/Description';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { ROW_TYPES } from 'workflow/constants/newInbox';
import DetailRows from '../DetailRows/DetailRows';
import { VIEWS } from 'workflow/constants/newInbox';
import { colorBlue1, colorGrey2 } from 'styles/_colors.scss';
import styles from './DocumentDetail.scss';

const BUTTON_TEXT = {
    EXPAND: 'Expand',
    COLLAPSE: 'Collapse'
};

const ExpandCollapseButton = ({ expanded, onClickHandler }) => {
    const btnText = expanded ? BUTTON_TEXT.COLLAPSE : BUTTON_TEXT.EXPAND;
    return (
        <div className={styles.DocumentDetail__Button} onClick={onClickHandler} data-cy="DocumentDetail">
            <span className={styles.DocumentDetail__ButtonLabel} data-cy="DocumentDetail-btnText">{btnText}</span>
            <span className={expanded ? styles.DocumentDetail__ButtonCollapse : styles.DocumentDetail__ButtonExpand}>
                <KeyboardArrowDownIcon style={{ color: colorBlue1 }} />
            </span>
        </div>
    );
};

const rowConfigs = [
    {
        label: 'File Id',
        field: 'documentIdentifier'
    },
    {
        label: 'Uploaded By',
        field: 'uploadUser.displayName'
    },
    {
        label: 'Email Address',
        field: 'uploadUser.emailAddress'
    },
    {
        label: 'Upload Date',
        field: 'uploadDate',
        type: ROW_TYPES.DATETIME
    },
    {
        label: 'Signatures',
        field: 'signatures',
        type: ROW_TYPES.LIST
    }
];

const DocumentDetail = ({ changeView, documentDetail = {} }) => {
    const { name } = documentDetail;
    const [expanded, setExpanded] = useState(false);

    const navigateToDocumentDetailView = () => changeView(VIEWS.DOCUMENT_DETAIL);

    return (
        <div className={styles.DocumentDetail} data-cy="DocumentDetail-DocumentDetail">
            <div className={styles.DocumentDetail__Header}>
                <span className={styles.DocumentDetail__HeaderTitle}>Document Details</span>
                <ExpandCollapseButton expanded={expanded} onClickHandler={() => setExpanded(!expanded)} />
            </div>
            {expanded && (
                <div className={styles.DocumentDetail__RowContainer}>
                    <div className={styles.DocumentDetail__NameRow} onClick={navigateToDocumentDetailView}>
                        <DescriptionIcon style={{ color: colorGrey2 }} />
                        <span data-cy="DocumentDetail-name">{name}</span>
                    </div>
                    <DetailRows data={documentDetail} configs={rowConfigs} />
                </div>
            )}
        </div>
    );
};

export { BUTTON_TEXT, ExpandCollapseButton };
export default DocumentDetail;
